import React from "react";
import { cn } from "@/lib/utils";
import { Progress } from "@/components/ui/progress";
import {
  Tooltip,
  TooltipTrigger,
  TooltipContent,
} from "@/components/ui/tooltip";
import { WEEKLY_HASHTAG_SEARCH_MAX } from "constants/MediaLibrary";

interface HashtagUsageIndicatorProps {
  activeCount: number;
}

export const HashtagUsageIndicator: React.FC<HashtagUsageIndicatorProps> = ({
  activeCount,
}) => {
  const percentage = (activeCount / WEEKLY_HASHTAG_SEARCH_MAX) * 100;

  // Determine progress bar color based on usage
  const getProgressColor = () => {
    if (percentage >= 100) return "bg-red-500";
    if (percentage >= 80) return "bg-yellow-500";
    return "bg-blue-500";
  };

  return (
    <div className="flex items-center gap-2 px-3 py-2">
      <div className="flex-1 relative">
        <Progress value={percentage} className="h-2 bg-neutral-200" />
        {/* Overlay to apply custom color to the indicator */}
        <div
          className={cn(
            "absolute top-0 left-0 h-2 rounded-full transition-all",
            getProgressColor()
          )}
          style={{ width: `${Math.min(percentage, 100)}%` }}
        />
      </div>
      <span className="text-xs font-medium text-neutral-600 whitespace-nowrap">
        {activeCount}/{WEEKLY_HASHTAG_SEARCH_MAX}
      </span>
      <Tooltip>
        <TooltipTrigger asChild>
          <button
            type="button"
            className="text-neutral-400 hover:text-neutral-600 transition-colors"
            aria-label="Hashtag usage information"
          >
            <i className="fa-regular fa-circle-info text-xs" />
          </button>
        </TooltipTrigger>
        <TooltipContent className="max-w-[220px] text-left font-normal">
          Instagram allows 30 hashtag searches per 7-day rolling period. Each
          hashtag expires 7 days after activation.
        </TooltipContent>
      </Tooltip>
    </div>
  );
};

export default HashtagUsageIndicator;
